export class HistoryDataValue {
    constructor(time, values) {
        this.time = time;
        this.values = values;
    }
}
